<template>
  <div class="remark-file-list" :style="listStyle">
    <div
      v-for="(f, i) in files"
      :key="i"
      class="remark-file-item"
      :style="itemStyle"
      :title="fileTooltip(f)"
    >
      <a
        class="remark-file-link"
        :href="f.file_url"
        target="_blank"
      >
        <img
          v-if="isImage(f)"
          class="remark-file-thumb"
          :src="f.file_url"
          :style="thumbStyle"
          alt=""
        />
        <span
          v-else
          class="remark-file-thumb remark-file-icon"
          :style="thumbStyle"
        >{{ extOf(f) || 'FILE' }}</span>
      </a>
      <div class="remark-file-index">{{ isImage(f) ? '备注图 ' + (i + 1) : (f.file_name || extOf(f) || '文件') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      default: 80,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    thumbStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
    itemStyle() {
      return {
        width: `${this.size + 40}px`,
      };
    },
    listStyle() {
      return this.inline ? { display: 'inline-flex' } : {};
    },
  },
  methods: {
    fileTooltip(f) {
      const name = f.file_name || f.file_url || '';
      return f.file_size ? `${name}（${this.humanizeSize(f.file_size)}）` : name;
    },
    extOf(f) {
      return (f.file_ext || (f.file_name ? (f.file_name.split('.').pop() || '') : '')).toUpperCase();
    },
    isImage(f) {
      return ['JPG', 'JPEG', 'PNG', 'GIF', 'WEBP'].includes(this.extOf(f));
    },
    getHumanizedSize(number) {
      if (number < 1024) return `${number} B`;
      if (number < 1048576) {
        const kb = number / 1024;
        return `${Number.isInteger(kb) ? kb : kb.toFixed(1)} KB`;
      }
      if (number < 1073741824) {
        const mb = number / 1048576;
        return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
      }
      const gb = number / 1073741824;
      return `${Number.isInteger(gb) ? gb : gb.toFixed(1)} GB`;
    },
    humanizeSize(number) {
      return this.getHumanizedSize(number);
    },
  },
};
</script>

<style src="./index.css" scoped/>
